import useModalTabs from "./useModalTabs";

export default function useGoToNextTab<T>() {
    return useModalTabs<T>().goToNextTab;
}
